var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col-md-4 left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.inventory")) +
                " > " +
                _vm._s(_vm.$t("sidebar.inventoryvalue")) +
                "\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8 right" }, [
          _c(
            "div",
            { staticClass: "action" },
            [
              _c("base-filter-data-type", {
                attrs: { type: _vm.dataType, items: _vm.REPORT_DATA_TYPES },
                on: { onSelect: _vm.handleSelectDataType }
              }),
              _vm._v(" "),
              _c("base-dropdown-filter-download", {
                attrs: { items: _vm.DOWNLOAD_EXTS, loading: false },
                on: { onSelect: _vm.handleSelectDownload }
              }),
              _vm._v(" "),
              _c("base-dropdown-filter-date-range", {
                attrs: {
                  type: _vm.dateType,
                  range: { start: _vm.dateStart, end: _vm.dateEnd },
                  active: _vm.isAppliedFilter
                },
                on: { onSubmit: _vm.handleSubmitFilter },
                scopedSlots: _vm._u([
                  {
                    key: "add",
                    fn: function() {
                      return [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-12" }, [_c("hr")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c("section-title", {
                                attrs: {
                                  title:
                                    _vm.$t("message.selectwarehouse") + ":",
                                  fontweight: "bold"
                                }
                              }),
                              _vm._v(" "),
                              _c("base-dropdown", {
                                attrs: { options: _vm.whOptions },
                                model: {
                                  value: _vm.whSelected,
                                  callback: function($$v) {
                                    _vm.whSelected = $$v
                                  },
                                  expression: "whSelected"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content col-md-12" }, [
      !_vm.ready
        ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
        : _c(
            "div",
            { staticClass: "col-md-12 no-padding mt-2" },
            [
              1
                ? [
                    _c("section", { staticClass: "mt-2 mb-4" }, [
                      _c(
                        "div",
                        [
                          _c("section-title", {
                            attrs: {
                              title: _vm.datePeriod(_vm.dateStart, _vm.dateEnd),
                              fontweight: "bold"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "keep-alive",
                      [
                        _vm.dataType === _vm.REPORT_DATA_TYPE_VALUE.TABLE
                          ? _c("report-inventory-table", {
                              attrs: {
                                items: _vm.inventoryStocks,
                                columnNames: [
                                  {
                                    style: { width: "140px" },
                                    text: _vm.$t("message.cost")
                                  },
                                  {
                                    style: { width: "140px" },
                                    text: _vm.$t(
                                      "apps.inventory.message.balance"
                                    )
                                  },
                                  {
                                    style: { width: "140px" },
                                    text:
                                      _vm.$t(
                                        "apps.inventory.message.stockvalues"
                                      ) +
                                      " " +
                                      _vm.currency
                                  }
                                ],
                                pickKeys: ["cost", "totalBalance", "value"]
                              }
                            })
                          : _vm.dataType ===
                            _vm.REPORT_DATA_TYPE_VALUE.CHART_BAR
                          ? _c("report-inventory-chart", {
                              attrs: {
                                items: _vm.inventoryStocks,
                                selectedLabels: _vm.chartSelectedLabels,
                                mapLabels: {
                                  value: _vm.$t(
                                    "apps.inventory.message.stockvalues"
                                  )
                                },
                                showLegendLabels: false,
                                showAxisLabelCurrency: true,
                                colors: ["#ff7675"],
                                areaStyle: null,
                                type: "bar"
                              },
                              on: {
                                "update:selectedLabels": function($event) {
                                  _vm.chartSelectedLabels = $event
                                },
                                "update:selected-labels": function($event) {
                                  _vm.chartSelectedLabels = $event
                                }
                              }
                            })
                          : _vm.dataType ===
                            _vm.REPORT_DATA_TYPE_VALUE.CHART_LINE
                          ? _c("report-inventory-chart", {
                              attrs: {
                                items: _vm.inventoryStocks,
                                selectedLabels: _vm.chartSelectedLabels,
                                mapLabels: {
                                  value: _vm.$t(
                                    "apps.inventory.message.stockvalues"
                                  )
                                },
                                showLegendLabels: false,
                                showAxisLabelCurrency: true,
                                colors: ["#ff7675"],
                                areaStyle: {},
                                type: "line"
                              },
                              on: {
                                "update:selectedLabels": function($event) {
                                  _vm.chartSelectedLabels = $event
                                },
                                "update:selected-labels": function($event) {
                                  _vm.chartSelectedLabels = $event
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.nodatafound")) +
                        "\n      "
                    )
                  ]
            ],
            2
          )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73117b40", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73117b40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/report/inventory/Value.vue
// module id = null
// module chunks = 